<template>
  <div>
    The page you are looking for does not exist
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped></style>
